import { render, staticRenderFns } from "./zzfj.vue?vue&type=template&id=593d9844&scoped=true"
import script from "./zzfj.vue?vue&type=script&lang=ts"
export * from "./zzfj.vue?vue&type=script&lang=ts"
import style0 from "./zzfj.vue?vue&type=style&index=0&id=593d9844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d9844",
  null
  
)

export default component.exports